import React from 'react';

const FaixaAnimada = () => {
  // Itens que vão ficar rodando
  const itens = [
    "Menos queda de pelos",
    "•",
    "Pelagem mais bonita",
    "•",
    "Mais energia e disposição",
    "•",
    "Digestão equilibrada e fezes firmes",
    "•",
    "Pele mais saudável e sem irritações",
    "•",
    "Maior resistência e imunidade",
    "•",
    "Mobilidade preservada",
    "•"
  ];

  
  const conteudo = [...itens, ...itens, ...itens, ...itens];

  return (
    <div style={styles.wrapper}>
      <div style={styles.track}>
        {conteudo.map((texto, index) => (
          <span key={index} style={styles.texto}>
            {texto}
          </span>
        ))}
      </div>
      
      {/* Estilos da Animação Injetados */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    backgroundColor: '#397449', // VERDE OFICIAL
    padding: '12px 0',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  track: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    // AQUI ESTÁ O SEGREDO DA VELOCIDADE:
    // 60s = 60 segundos para dar uma volta (Bem lento e suave)
    // Se quiser mais rápido, diminua para 30s. Se quiser mais lento, aumente para 80s.
    animation: 'scroll 60s linear infinite', 
  },
  texto: {
    color: '#fff',
    fontFamily: '"Commissioner", sans-serif',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginRight: '40px', // Espaço entre os textos
    display: 'inline-block',
    letterSpacing: '1px'
  }
};

export default FaixaAnimada;